import React, { useEffect, useRef, useState } from "react"
import {
  Alert,
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Drawer, Switch, Input as AntdInput, Select, Form as AntdForm, InputNumber } from "antd"
import {
  deleteTracker,
  teliaSimStatus,
  updateNavigilData,
  updateTracker,
} from "helpers/backend_helper"
import * as Yup from "yup"
import { useFormik } from "formik"
import SelectOrder from "components/DropdownList/SelectOrder"
import OnTheGoServices from "pages/Services/OnTheGo/OnTheGoServices"
import { showToast } from "utils/general"
import NavigilSettings from "./NavigilSettings"
import TrackerSmsTab from "./TrackerSmsTab"
import withRouter from "components/Common/withRouter"
import SimStatusDropdown from "components/Misc/SimStatusDropdown"
import TrackerDataStreamTab from "./TrackerDataStreamTab"
const { TextArea } = AntdInput;

const TrackerDrawer = props => {
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [update, setUpdate] = useState(false)
  const [ongoingDelete, setOngoingDelete] = useState(false)
  const [ongoingAction, setOngoingAction] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [simDropdownOpen, setSimDropdownOpen] = useState(false)
  const [activeTab, setActiveTab] = useState("1")

  const [renderSmsTab, setRenderSmsTab] = useState(false)
  const [renderClientTab, setRenderClientTab] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Update client validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      orderNumber: props.selectedRow?.orderNumber || "",
      name: props.selectedRow?.name || "",
      gsm: props.selectedRow?.gsm || "",
      imei: props.selectedRow?.imei || "",
      imsi: props.selectedRow?.imsi || "",
      iccid: props.selectedRow?.iccid || "",
      batch: props.selectedRow?.batch || "",
      firmware: props.selectedRow?.firmware || "",
      serial: props.selectedRow?.serial || "",
      serverNumber: props.selectedRow?.serverNumber || "",
      trackerType: props.selectedRow?.type || "",
      trackerId: props.selectedRow?.trackerId || "",
      geofenceDynamicLocation:
        props.selectedRow?.geofenceDynamicLocation || false,
      locationQuerySms: props.selectedRow?.locationQuerySms || false,
      remarks: props.selectedRow?.remarks || "",
      statusCheckHour: props.selectedRow?.statusCheckHour || undefined,
      statusCheckInterval: props.selectedRow?.statusCheckInterval || 0,
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      setSuccess("")
      setError("")
      setUpdate(true)

      let temp = structuredClone(values)
      temp.orderNumber = temp.orderNumber ? temp.orderNumber : ""
      if (!temp.statusCheckHour) temp.statusCheckHour = 0
      if (!temp.statusCheckInterval) temp.statusCheckInterval = 0

      updateTracker(abortRef.current, props.selectedRow?.key, temp)
        .then(result => {
          setUpdate(false)
          if (result.statusCode == 200) {
            setSuccess("Updated")
            props.getTrackers()
          } else {
            setError("Error")
          }
        })
        .catch(err => {
          console.log(err)
          setUpdate(false)
          setError("Error")
        })
    },
  })

  // Selected order changed
  const orderSelectionChanged = value => {
    validation.setFieldValue("orderNumber", value)
  }

  // Delete device
  const deleteDevice = () => {
    if (props.selectedRow != null && props.selectedRow.key.length > 0) {
      setOngoingDelete(true)
      deleteTracker(abortRef.current, props.selectedRow.key)
        .then(result => {
          if (result.statusCode === 200) {
            if (result.statusDescription == "OK") {
              setDeleteModal(false)
              showToast(props.t("Deleted"), "success")
              props.getTrackers()
              props.setShowDrawer(false)
            } else {
              showToast(props.t("Unable to delete linked device"), "error")
            }
          } else {
            showToast(props.t("Error"), "error")
          }
          setOngoingDelete(false)
        })
        .catch(err => {
          showToast(props.t("Error"), "error")
          setOngoingDelete(false)
        })
    }
  }

  // SIM status
  const simStatusAction = status => {
    if (props.selectedRow?.imsi && !ongoingAction) {
      setOngoingAction(true)
      teliaSimStatus(abortRef.current, props.selectedRow.imsi, status)
        .then(result => {
          if (result.statusCode === 200) {
            showToast(props.t("Status") + ": " + result.simStatus, "success")
            props.getTrackers()
          }
          else if (result.errorMessage) {
            showToast(props.t("Error") + ": " + result.errorMessage, "error")
          }
          else {
            showToast(props.t("Error"), "error")
          }
        })
        .catch(err => {
          showToast(props.t("Error"), "error")
        })
        .finally(() => {
          setOngoingAction(false)
        })
    }
  }

  // Navigil data update
  const updateNavigil = () => {
    if (props.selectedRow?.key && !ongoingAction) {
      setOngoingAction(true)
      updateNavigilData(abortRef.current, props.selectedRow.key)
        .then(result => {
          if (result.statusCode === 200) {
            showToast(props.t("Success"), "success")
            props.getTrackers()
          } else {
            showToast(props.t("Error"), "error")
          }
        })
        .catch(err => {
          showToast(props.t("Error"), "error")
        })
        .finally(() => {
          setOngoingAction(false)
        })
    }
  }

  return (
    <>
      <Drawer
        title={
          props.t("Tracker") +
          " " +
          props.selectedRow?.name
        }
        width={"85%"}
        placement="right"
        onClose={() => {
          props.setShowDrawer(false)
          setError("")
          setSuccess("")
          setActiveTab("1")
          setRenderSmsTab(false)
          setRenderClientTab(false)
        }}
        open={props.showDrawer}
        zIndex={1003}
      //bodyStyle={{ backgroundColor: "#f8f8f8" }}
      >
        <div className="d-flex flex-wrap mb-3">
          <ul className="nav icon-tab">
            <NavItem>
              <NavLink
                active={activeTab === "1"}
                onClick={() => {
                  setActiveTab("1")
                }}
              >
                {props.t("Management panel")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "3"}
                onClick={() => {
                  setActiveTab("3")
                  setRenderSmsTab(true)
                }}
              >
                {props.t("SMS logs")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "5"}
                onClick={() => {
                  setActiveTab("5")
                  setRenderClientTab(true)
                }}
              >
                {props.t("Client view")}
              </NavLink>
            </NavItem>
            {props.selectedRow?.type == "MiniFinderGPRS" && (
              <NavItem>
                <NavLink
                  active={activeTab === "4"}
                  onClick={() => {
                    setActiveTab("4")
                  }}
                >
                  {props.t("Data stream")}
                </NavLink>
              </NavItem>
            )}
            {props.selectedRow?.type == "Navigil" && (
              <NavItem>
                <NavLink
                  active={activeTab === "2"}
                  onClick={() => {
                    setActiveTab("2")
                  }}
                >
                  {props.t("Navigil settings")}
                </NavLink>
              </NavItem>
            )}
          </ul>
        </div>

        <TabContent activeTab={activeTab}>
          <TabPane className="show" tabId="1">
            <Row xs={1} xl={2}>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">
                      {props.t("Settings")}
                    </CardTitle>
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        return false
                      }}
                    >
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Description")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("Description")}
                              value={validation.values.name}
                              onChange={(v) => { validation.setFieldValue("name", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row xs={1} md={2}>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Type")}</Label>
                            <Select
                              value={validation.values.trackerType}
                              placeholder={props.t("Choose")}
                              onChange={(v) => { validation.setFieldValue("trackerType", v) }}
                              options={[
                                { label: props.t("Undefined"), value: "" },
                                { label: props.t("Farnear"), value: "Farnear" },
                                { label: props.t("MiniFinder"), value: "MiniFinder" },
                                { label: props.t("MiniFinderGPRS"), value: "MiniFinderGPRS" },
                                { label: props.t("MiniFinderSMS"), value: "MiniFinderSMS" },
                                { label: props.t("Navigil"), value: "Navigil" },
                                { label: props.t("Yepzon"), value: "Yepzon" },
                              ]}
                              style={{ width: 100 + "%" }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("GSM")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("GSM")}
                              value={validation.values.gsm}
                              onChange={(v) => { validation.setFieldValue("gsm", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Serial")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("Serial")}
                              value={validation.values.serial}
                              onChange={(v) => { validation.setFieldValue("serial", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("IMEI")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("IMEI")}
                              value={validation.values.imei}
                              onChange={(v) => { validation.setFieldValue("imei", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("IMSI")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("IMSI")}
                              value={validation.values.imsi}
                              onChange={(v) => { validation.setFieldValue("imsi", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("ICCID")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("ICCID")}
                              value={validation.values.iccid}
                              onChange={(v) => { validation.setFieldValue("iccid", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        {validation.values.trackerType == "Navigil" && (
                          <Col>
                            <FormGroup>
                              <Label>{props.t("Device ID")}</Label>
                              <AntdInput
                                allowClear
                                placeholder={props.t("Device ID")}
                                value={validation.values.trackerId}
                                onChange={(v) => { validation.setFieldValue("trackerId", v.target.value) }}
                              />
                            </FormGroup>
                          </Col>
                        )}
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Firmware")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("Firmware")}
                              value={validation.values.firmware}
                              onChange={(v) => { validation.setFieldValue("firmware", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Batch")}</Label>
                            <AntdInput
                              allowClear
                              placeholder={props.t("Batch")}
                              value={validation.values.batch}
                              onChange={(v) => { validation.setFieldValue("batch", v.target.value) }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Server number")}</Label>
                            <Select
                              value={validation.values.serverNumber}
                              placeholder={props.t("Choose")}
                              onChange={(v) => { validation.setFieldValue("serverNumber", v) }}
                              options={[
                                { label: props.t("Undefined"), value: "" },
                                { label: "31811", value: "31811" },
                                { label: "+3584573950158", value: "+3584573950158" },
                                { label: "+358509020154", value: "+358509020154" },
                                { label: "+61428449770", value: "+61428449770" },
                                { label: "+4759447471", value: "+4759447471" },
                              ]}
                              style={{ width: 100 + "%" }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>
                              {props.t("Status query interval")}
                            </Label>
                            <InputNumber
                              value={validation.values.statusCheckInterval}
                              suffix={props.t("hours")}
                              style={{ width: "100%" }}
                              min={0}
                              max={72}
                              onChange={v => {
                                validation.setFieldValue(
                                  "statusCheckInterval",
                                  v
                                )
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>
                              {props.t("Daily status query")}
                            </Label>
                            <Select
                              value={validation.values.statusCheckHour}
                              placeholder={props.t("Choose")}
                              allowClear
                              prefix={props.t("at")}
                              onChange={v => {
                                validation.setFieldValue("statusCheckHour", v)
                              }}
                              options={[
                                { label: "01:00", value: 1 },
                                { label: "02:00", value: 2 },
                                { label: "03:00", value: 3 },
                                { label: "04:00", value: 4 },
                                { label: "05:00", value: 5 },
                                { label: "06:00", value: 6 },
                                { label: "07:00", value: 7 },
                                { label: "08:00", value: 8 },
                                { label: "09:00", value: 9 },
                                { label: "10:00", value: 10 },
                                { label: "11:00", value: 11 },
                                { label: "12:00", value: 12 },
                                { label: "13:00", value: 13 },
                                { label: "14:00", value: 14 },
                                { label: "15:00", value: 15 },
                                { label: "16:00", value: 16 },
                                { label: "17:00", value: 17 },
                                { label: "18:00", value: 18 },
                                { label: "19:00", value: 19 },
                                { label: "20:00", value: 20 },
                                { label: "21:00", value: 21 },
                                { label: "22:00", value: 22 },
                                { label: "23:00", value: 23 },
                                { label: "24:00", value: 24 },
                              ]}
                              style={{ width: 100 + "%" }}
                            />
                          </FormGroup>
                        </Col>
                        {validation.values.trackerType == "Farnear" && (
                          <Col>
                            <FormGroup className="mt-2">
                              <Label>{props.t("Locate before geofence")}</Label>
                              <Switch
                                className="d-block"
                                checkedChildren={
                                  <i className="mdi mdi-check-bold" />
                                }
                                unCheckedChildren={
                                  <i className="mdi mdi-close-thick" />
                                }
                                name="geofenceDynamicLocation"
                                checked={
                                  validation.values.geofenceDynamicLocation
                                }
                                onChange={v => {
                                  validation.setFieldValue(
                                    "geofenceDynamicLocation",
                                    v
                                  )
                                }}
                              />
                            </FormGroup>
                          </Col>
                        )}
                        {validation.values.trackerType == "MiniFinderGPRS" && (
                          <Col>
                            <FormGroup className="mt-2">
                              <Label>{props.t("Locate via SMS")}</Label>
                              <Switch
                                className="d-block"
                                checkedChildren={
                                  <i className="mdi mdi-check-bold" />
                                }
                                unCheckedChildren={
                                  <i className="mdi mdi-close-thick" />
                                }
                                name="locationQuerySms"
                                checked={validation.values.locationQuerySms}
                                onChange={v => {
                                  validation.setFieldValue(
                                    "locationQuerySms",
                                    v
                                  )
                                }}
                              />
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Order number")}</Label>
                            <SelectOrder
                              selection={validation.values.orderNumber}
                              setSelectedOrder={orderSelectionChanged}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>{props.t("Remarks")}</Label>
                            <AntdForm.Item validateStatus={validation.values.remarks?.length > 0 ? "error" : ""}>
                              <TextArea
                                allowClear
                                autoSize={{ minRows: 1, maxRows: 6 }}
                                value={validation.values.remarks}
                                onChange={(v) => { validation.setFieldValue("remarks", v.target.value) }}
                              />
                            </AntdForm.Item>
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="mt-2 mb-3 d-flex justify-content-center">
                        <Button
                          color="primary"
                          disabled={update}
                          style={{ minWidth: "150px" }}
                          onClick={() => {
                            validation.submitForm()
                          }}
                        >
                          {props.t("Save")}
                        </Button>
                      </div>
                      {error ? (
                        <Alert color="danger">{props.t(error)}</Alert>
                      ) : null}
                      {success ? (
                        <Alert color="success">{props.t(success)}</Alert>
                      ) : null}
                    </Form>
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">{props.t("Actions")}</CardTitle>
                    <ListGroup className="list-group-flush">
                      {props.selectedRow?.gsm.indexOf("453") == 0 && (
                        <ListGroupItem className="pb-4">
                          <Row>
                            <Col>
                              <div>
                                <h6>
                                  {props.t("SIM - IMSI") +
                                    " (" +
                                    props.selectedRow?.simStatus +
                                    ")"}
                                </h6>
                                <span className="text-muted">
                                  {props.t("Check or change SIM status")}
                                </span>
                              </div>
                            </Col>
                            <Col className="col-auto">
                              <ButtonDropdown
                                isOpen={simDropdownOpen}
                                toggle={() => {
                                  setSimDropdownOpen(!simDropdownOpen)
                                }}
                              >
                                <DropdownToggle
                                  color="primary"
                                  style={{ minWidth: "100px" }}
                                  caret
                                >
                                  {props.t("Select action")}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    disabled={
                                      ongoingAction || !props.selectedRow?.imsi
                                    }
                                    onClick={() => {
                                      simStatusAction(undefined)
                                    }}
                                  >
                                    {props.t("Check")}
                                  </DropdownItem>
                                  <DropdownItem
                                    disabled={
                                      ongoingAction || !props.selectedRow?.imsi
                                    }
                                    onClick={() => {
                                      simStatusAction("Activate")
                                    }}
                                  >
                                    {props.t("Activate")}
                                  </DropdownItem>
                                  <DropdownItem
                                    disabled={
                                      ongoingAction || !props.selectedRow?.imsi
                                    }
                                    onClick={() => {
                                      simStatusAction("Pause")
                                    }}
                                  >
                                    {props.t("Pause")}
                                  </DropdownItem>
                                  <DropdownItem
                                    disabled={
                                      ongoingAction || !props.selectedRow?.imsi
                                    }
                                    onClick={() => {
                                      simStatusAction("Terminate")
                                    }}
                                  >
                                    {props.t("Terminate")}
                                  </DropdownItem>
                                </DropdownMenu>
                              </ButtonDropdown>
                            </Col>
                          </Row>
                        </ListGroupItem>
                      )}

                      {props.selectedRow?.iccid && (
                        <ListGroupItem className="pb-4">
                          <SimStatusDropdown iccid={props.selectedRow.iccid} />
                        </ListGroupItem>
                      )}

                      {props.selectedRow?.type === "Navigil" && (
                        <ListGroupItem className="pb-4">
                          <Row>
                            <Col>
                              <div>
                                <h6>{props.t("Update Navigil data")}</h6>
                                <span className="text-muted">
                                  {props.t(
                                    "Fetch and update device information"
                                  )}
                                </span>
                              </div>
                            </Col>
                            <Col className="col-auto">
                              <Button
                                color="primary"
                                disabled={
                                  ongoingAction || !props.selectedRow?.serial
                                }
                                style={{ minWidth: "100px" }}
                                onClick={() => {
                                  updateNavigil()
                                }}
                              >
                                {props.t("Update")}
                              </Button>
                            </Col>
                          </Row>
                        </ListGroupItem>
                      )}

                      <ListGroupItem className="pb-4">
                        <Row>
                          <Col>
                            <div>
                              <h6>{props.t("Deletion")}</h6>
                              <span className="text-muted">
                                {props.t(
                                  "The device and all related data will be deleted permanently"
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col className="col-auto">
                            <Button
                              color="danger"
                              style={{ minWidth: "100px" }}
                              onClick={() => {
                                setDeleteModal(true)
                              }}
                            >
                              {props.t("Delete")}
                            </Button>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    </ListGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          <TabPane className="show" tabId="3">
            {props.selectedRow?.key && renderSmsTab && (
              <TrackerSmsTab
                gsm={props.selectedRow?.gsm}
                serverNumber={props.selectedRow?.serverNumber}
              ></TrackerSmsTab>
            )}
          </TabPane>

          <TabPane className="show" tabId="2">
            {props.selectedRow?.key && (
              <NavigilSettings deviceId={props.selectedRow.trackerId} />
            )}
          </TabPane>

          <TabPane className="show" tabId="4">
            {props.selectedRow?.imei && (
              <TrackerDataStreamTab imei={props.selectedRow?.imei} />
            )}
          </TabPane>

          <TabPane className="show" tabId="5">
            {props.selectedRow?.key && renderClientTab && (
              <OnTheGoServices trackerKey={props.selectedRow?.key} />
            )}
          </TabPane>
        </TabContent>
      </Drawer>

      <Modal
        isOpen={deleteModal}
        toggle={() => {
          setDeleteModal(!deleteModal)
        }}
        centered
      >
        <ModalHeader>{props.t("Delete confirmation")}</ModalHeader>
        <ModalBody>
          <p>
            {props.t("Are you sure you want to delete") +
              " " +
              props.selectedRow?.name +
              "?"}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            outline
            onClick={() => {
              setDeleteModal(false)
            }}
          >
            {props.t("Cancel")}
          </Button>
          <Button
            disabled={ongoingDelete}
            color="danger"
            onClick={() => {
              deleteDevice()
            }}
          >
            {props.t("Delete")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

TrackerDrawer.propTypes = {
  t: PropTypes.any,
  showDrawer: PropTypes.bool,
  setShowDrawer: PropTypes.any,
  selectedRow: PropTypes.any,
  getTrackers: PropTypes.func,
}

export default withRouter(withTranslation()(TrackerDrawer))
